import axios from 'axios';
import Cookies from 'js-cookie';

const workitApiUrl = process.env.VUE_APP_WORKIT_API_URL?.trim()
    || `${window.location.protocol}//${window.location.hostname}:4444`;

const workitClient = axios.create({
    baseURL: workitApiUrl,
    headers: {
        Accept: 'application/json',
    },
});

workitClient.interceptors.request.use((request) => {
    const token = Cookies.get('accessToken') || '';
    request.headers.Authorization = `Bearer ${token}`;
    request.headers.companyId = localStorage.getItem('selectedCompany') || '';
    request.headers['X-Request-ID'] = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return request;
});

workitClient.interceptors.response.use(
    (response) => response,
    // WorkIT is a companion backend. Its 401 response can be caused by local
    // configuration or token validation differences, so it must never refresh
    // or invalidate the active Kompact session.
    (error) => Promise.reject(error),
);

export const workitRequest = (method, endpoint, data) => {
    if (method === 'get' || method === 'delete') {
        return workitClient[method](endpoint);
    }
    return workitClient[method](endpoint, data);
};

export default workitClient;
